import { getLabelName, getLabelTooltip } from '@apia/util';
import { Checkbox, TCheckboxProps } from '../../components';
import { ValidatedCollectorField } from '../ValidatedCollectorField';

export class CollectorCheckbox extends ValidatedCollectorField<
  string | boolean,
  Omit<TCheckboxProps, 'name'>
> {
  type = 'checkbox';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <Checkbox
        {...props}
        initialValue={this.config.initialValue}
        validationFunction={validationFunction}
        name={this.name}
        label={getLabelName(this.label)}
        title={getLabelTooltip(this.label)}
        validationRules={rules}
        avoidSemicolon
        removeOnUnmount={false}
        avoidRegisterIfExists
      />
    );
  };
}
